import moment from 'moment';

/**
 * Formata uma data assumindo que o backend retorna em UTC (formato MySQL
 * "YYYY-MM-DD HH:mm:ss" sem marcador de timezone) e converte para horário
 * de Brasília (UTC-3).
 *
 * Uso: formatBrasilia(certUser.deadline_send_report) → "18/06/26 - 12:11"
 */
export const formatBrasilia = (
  date: string | Date | null | undefined,
  fmt: string = 'DD/MM/YY - HH:mm'
): string => {
  if (!date) return '';
  return moment.utc(date).utcOffset(-180).format(fmt);
};
